export var Orientation = /*#__PURE__*/ function(Orientation) {
    Orientation["vertical"] = "vertical";
    Orientation["horizontal"] = "horizontal";
    return Orientation;
}({});
export var StepState = /*#__PURE__*/ function(StepState) {
    StepState["active"] = "active";
    StepState["completed"] = "completed";
    StepState["pending"] = "pending";
    return StepState;
}({});
export var IconType = /*#__PURE__*/ function(IconType) {
    IconType["default"] = "default";
    IconType["featuredIcon"] = "featuredIcon";
    return IconType;
}({});
export var StepSize = /*#__PURE__*/ function(StepSize) {
    StepSize["sm"] = "sm";
    StepSize["md"] = "md";
    return StepSize;
}({});
